import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StatementTable, WalletTable, EarningsTable } from "./";
import Tabs from "react-responsive-tabs";
import style from "./ilifepoint.module.scss";
import { useSelector } from "react-redux";
import HistorysTable from "./HistorysTable";

const stylees = {
  paddingTop: "10px",
  fontFamily: "system-ui",
};

function Content({
  tableData,
  changeHandler,
  paginationHandler,
  repurchase_status,
  exportData,
  selectedTab,
  loader,
  state,
}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const [tabs, setTabs] = useState([]);
  const [selectedTabKey, setSelectedTabKey] = useState("");

  useEffect(() => {
    const newTabs = [];
    if (state.fourpCodeListAndHistory) {
      newTabs.push("fourpcodelisthistory");
    }
    if (state.fourpActivatedProductList) {
      newTabs.push("activatedproductlist");
    }

    if (newTabs.length > 0) {
      if (newTabs.includes("fourpcodelisthistory")) {
        setSelectedTabKey("fourpcodelisthistory");
      } else {
        setSelectedTabKey("activatedproductlist");
      }
    } else {
      setSelectedTabKey(""); // Clear selectedTabKey if no tabs are present
    }

    setTabs(newTabs);
  }, [state.fourpCodeListAndHistory, state.fourpActivatedProductList]);

  const getTabs = () => {
    return tabs.map((tab, index) => ({
      title: t("Common." + tab),
      getContent: () => getContent(tab),
      key: tab,
      tabClassName: style.TabClass,
      panelClassName: style.TabPanel,
    }));
  };

  const getContent = (contentId) => {
    console.log(contentId, "contentId goes here");
    if (contentId === "statement") {
      return (
        <div className={style.dataTable} style={stylees}>
          <StatementTable
            ContentData={tableData.statement}
            paginationchange={paginationHandler.statement}
          />
        </div>
      );
    } else if (contentId === "purchaseWallet") {
      return (
        <div className={style.dataTable} style={stylees}>
          <WalletTable
            ContentData={tableData.wallet}
            paginationchange={paginationHandler.wallet}
          />
        </div>
      );
    } else if (contentId === "activatedproductlist") {
      console.log("==== inside activated product list ====");
      return (
        <div className={style.dataTable} style={stylees}>
          <EarningsTable
            loader={loader}
            ContentData={tableData.earnings}
            paginationchange={paginationHandler.earnings}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    } else if (contentId === "fourpcodelisthistory") {
      console.log(" === inside fourp code list history === ");
      return (
        <div className={style.dataTable} style={stylees}>
          <HistorysTable
            loader={loader}
            ContentData={tableData.history}
            paginationchange={paginationHandler.history}
            exportData={exportData}
            selectedTab={selectedTab}
          />
        </div>
      );
    }
  };

  return (
    <div className={style.summary}>
      <div
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_tabContent}`
            : `${style.tabContent}`
        }`}
      >
        {tabs.length > 0 && (
          <Tabs
            items={getTabs()}
            transform={true}
            transformWidth={734}
            onChange={changeHandler}
            selectedTabKey={selectedTabKey}
          />
        )}
      </div>
    </div>
  );
}

export default Content;
